import React, { useContext } from 'react'
import { isEmpty } from 'lodash'
import { TemplateContext } from '../../context/template'
import { AppContext } from '../../context/app'
import LoginRegister from '../../components/auth/loginRegister'
import EclipseSignInModal from './eclipseSignInModal'
import EclipseSignUpModal from './eclipseSignUpModal'
import EliteEdgeSignInModal from './eliteEdgeSignInModal'
import SceneCenterSignInModal from './sceneCenterSignInModal'
import EliteEdgeSignUpModal from './eliteEdgeSignUpModal'
import SceneCenterSignUpModal from './sceneCenterSignUpModal'
import CrescendoSignUpModal from './crescendoSignUpModal'

const LoginTemplateModal = () => {
  const { loginTemplateData, loginTemplateLoaded, signUpTemplateData, signupTemplateLoaded } =
    useContext(TemplateContext)
  const { modalType } = useContext(AppContext)

  const getLoginComponent = (key, data) => {
    const pageProps = {
      data,
      modifyData: () => {},
      setModalState: () => {},
      isEdit: false,
    }

    const loginComponents = {
      eclipseSignIn: <EclipseSignInModal {...pageProps} />,
      eliteEdgeSignIn: <EliteEdgeSignInModal {...pageProps} />,
      sceneCenterSignIn: <SceneCenterSignInModal {...pageProps} />,
      playmakersSignIn: <SceneCenterSignInModal {...pageProps} />,
      crescendoSignIn: <SceneCenterSignInModal {...pageProps} />,
    }

    return loginComponents[key] || <LoginRegister />
  }

  const getSignupComponent = (key, data) => {
    const pageProps = {
      data,
      modifyData: () => {},
      setModalState: () => {},
      isEdit: false,
    }

    const signupComponents = {
      eclipseSignUp: <EclipseSignUpModal {...pageProps} />,
      eliteEdgeSignUp: <EliteEdgeSignUpModal {...pageProps} />,
      sceneCenterSignUp: <SceneCenterSignUpModal {...pageProps} />,
      playMakersSignUp: <SceneCenterSignUpModal {...pageProps} />,
      crescendoSignUp: <CrescendoSignUpModal {...pageProps} />,
    }

    return signupComponents[key] || <LoginRegister />
  }

  const getPage = () => {
    if (modalType === 'login') {
      if (loginTemplateLoaded && !isEmpty(loginTemplateData) && loginTemplateData.template_key) {
        return getLoginComponent(loginTemplateData.template_key, loginTemplateData.data)
      }
    }

    if (modalType === 'register') {
      if (signupTemplateLoaded && !isEmpty(signUpTemplateData) && signUpTemplateData.template_key) {
        return getSignupComponent(signUpTemplateData.template_key, signUpTemplateData.data)
      }
    }

    return <LoginRegister />
  }

  return <div className="w-full h-full">{getPage()}</div>
}

export default LoginTemplateModal
